import React from 'react';
import _ from 'lodash';
import { ChartProp } from '../../enum/apiResultProp/ChartProp';
import { ChartType } from '../../enum/ChartType';
import BarChart from './BarChart';
import LineChart from './LineChart';

export default ({ screenComponentProps }) => {

    let chart = null;

    let props = { chartProps: screenComponentProps };
    
    const chartType = screenComponentProps[ChartProp.ChartType];
    if (chartType === ChartType.BarChart) {
        chart = <BarChart {...props} />
    } else if (chartType === ChartType.LineChart) {
        chart = <LineChart {...props} />
    } else {
        chart = <p>Chart Type not registered - {chartType}</p>;
    }

    return chart;
}